<template>
  <div id="property-modal" class="modal"  v-show="modalShown">
    <div class="modal-main">
      <div class="title-area">
        <h2>ルーム情報設定</h2>
      </div>
      <!-- ローディングモーダル -->
      <dd-loading-modal ref="loadingModalRef" />
      <div v-if="isInput" class="data-area">
        <ul>
          <li>
            <span class="label">棟名</span>
            <input type="text" v-if="editRoomData" v-model="editRoomData.cpropertyBuildingName">
            <input type="text" v-else v-model="propertyBuildingName" placeholder="棟名">
            <div class="validate_error_messages">{{ validateErrorMessages.propertyBuildingName }}</div>
          </li>
          <li>
            <span class="label">フロア名</span>
            <input type="text" v-if="editRoomData" v-model="editRoomData.cpropertyFloorName">
            <input type="text" v-else v-model="propertyFloorName" placeholder="フロア名">
            <div class="validate_error_messages">{{ validateErrorMessages.propertyFloorName }}</div>
          </li>
           <li>
            <span class="label">部屋名<span class="required">【必須】</span></span>
            <input type="text" v-if="editRoomData" v-model="editRoomData.cpropertyRoomName">
            <input type="text" v-else v-model="propertyRoomName" placeholder="部屋名">
            <div class="validate_error_messages">{{ validateErrorMessages.propertyRoomName }}</div>
          </li>
        </ul>
      </div>
      <div v-else class="message">
        <span>ルームを選択してください</span>
      </div>
      <div class="button-area">
      <button type="button" class="main_btn" v-if="editRoomData && isInput" @click="updateRoomData">設定</button>
      <button type="button" class="main_btn" v-else-if="isInput" @click="updateRoomData">登録</button>
      <button type="button" class="main_btn" @click="onCancel">キャンセル</button>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import * as Api from '../../../utils/Api'
import * as AppUtil from '../../../utils/App'
import {API_URL} from '../../../constants/App'
import LoadingModal from '../../common/LoadingModal'

export default {
  name: 'RoomModal',
  components: {
    'dd-loading-modal': LoadingModal
  },
  props: {
  },
  data () {
    return {
      /** モーダル開閉 */
      modalShown: false,

      /** ルーム情報 */
      propertyId: null,
      propertyBuildingName: null,
      propertyFloorName: null,
      propertyRoomName: null,

      /** 編集中データ */
      editRoomData: null,
      /** 入力エリア表示フラグ */
      isInput: false,
      validateErrorMessages: {}
    }
  },
  methods: {
    /** 新規モーダル */
    showNewModal: function (id) {
      this.clearData()
      this.propertyId = id
      this.isInput = true
      this.modalShown = true
    },
    /** 編集モーダル */
    showEditModal: function (data) {
      this.editRoomData = null
      this.isInput = data != null
      this.editRoomData = Object.assign({}, data)
      this.propertyId = data != null ? data.cpropertyId : null
      this.modalShown = true
    },
    /** キャンセル */
    onCancel: function () {
      this.clearData()
      this.modalShown = false
    },
    /** ルーム情報更新 */
    updateRoomData: function () {
      this.$refs.loadingModalRef.showModal(true)
      let payload = {
        propertyRoomId: this.editRoomData ? this.editRoomData.cpropertyRoomId : null,
        propertyId: this.editRoomData ? this.editRoomData.cpropertyId : this.propertyId,
        propertyBuildingName: this.editRoomData ? this.editRoomData.cpropertyBuildingName : this.propertyBuildingName,
        propertyFloorName: this.editRoomData ? this.editRoomData.cpropertyFloorName : this.propertyFloorName,
        propertyRoomName: this.editRoomData ? this.editRoomData.cpropertyRoomName : this.propertyRoomName
      }
      if (!this.editRoomData) {
        axios.post(API_URL.PROPERTY + '/room/add', payload
        ).then(response => {
          this.$refs.loadingModalRef.showModal(false)
          let modalData = {
            messages: ['登録しました'],
            onOk: () => {
              this.modalShown = false
              this.$emit('getRoomList', this.propertyId)
            }
          }
          this.validateErrorMessages = {}
          AppUtil.showModal(modalData)
        }).catch(error => {
          this.$refs.loadingModalRef.showModal(false)
          this.validateErrorMessages = {}
          Api.handleError(error, this.errorMessage, this.validateErrorMessages)
        })
      } else {
        axios.post(API_URL.PROPERTY + '/room/update', payload
        ).then(response => {
          this.$refs.loadingModalRef.showModal(false)
          let modalData = {
            messages: ['変更しました'],
            onOk: () => {
              this.modalShown = false
              this.$emit('getRoomList', this.propertyId)
            }
          }
          this.validateErrorMessages = {}
          AppUtil.showModal(modalData)
        }).catch(error => {
          this.$refs.loadingModalRef.showModal(false)
          this.validateErrorMessages = {}
          Api.handleError(error, this.errorMessage, this.validateErrorMessages)
        })
      }
    },
    clearData: function () {
      this.propertyBuildingName = null
      this.propertyFloorName = null
      this.propertyRoomName = null
      this.editRoomData = null
      this.validateErrorMessages = {}
    }
  }
}
</script>
<style lang="scss" scoped>
li{
  margin-bottom: 20px;
  div{
    width: 175px;
    display: inline-block;
    padding: 10px;
    text-align: left;
  }
  .label{
    min-width: 190px;
    display: inline-block;
    text-align: left;
    font-weight: bold;
  }
}
.data-area {
  padding: 20px;
  max-height: 620px;
  overflow: auto;
}
.modal-main{
  max-height: 100%;
}
.count_limit{
  font-size: 8px;
}
.message{
  margin: 30px;
}
.validate_error_messages {
  color: #dc3545;
  text-align: left;
  min-width: 400px;
}
.required{
  color: #ff0000;
}

</style>



// WEBPACK FOOTER //
// src/main/js/components/list/modal/RoomModal.vue